interface DiffViewProps {
  /** unified diff 文本（逐行 +/-/@@ 前缀着色） */
  diff: string;
}

/**
 * 简单 unified diff 展示：新增行绿色、删除行红色、块头蓝色。
 * 配色使用主题变量，深浅色主题自适应。
 */
export default function DiffView({ diff }: DiffViewProps) {
  const lines = diff.split('\n');
  return (
    <pre
      style={{
        margin: 0,
        padding: '8px 0',
        background: 'var(--bg-primary)',
        border: '1px solid var(--border-default)',
        borderRadius: 'var(--radius-md)',
        fontFamily: "'JetBrains Mono', 'Fira Code', Consolas, 'Courier New', monospace",
        fontSize: 12,
        lineHeight: 1.6,
        overflow: 'auto',
        maxHeight: 360,
      }}
    >
      {lines.map((line, i) => {
        let color = 'var(--text-secondary)';
        let background = 'transparent';
        if (line.startsWith('@@')) {
          color = 'var(--color-primary)';
        } else if (line.startsWith('+') && !line.startsWith('+++')) {
          color = 'var(--color-success)';
          background = 'rgba(126, 231, 135, 0.08)';
        } else if (line.startsWith('-') && !line.startsWith('---')) {
          color = 'var(--color-error)';
          background = 'rgba(248, 81, 73, 0.08)';
        }
        return (
          <div key={i} style={{ color, background, padding: '0 12px', whiteSpace: 'pre' }}>
            {line || ' '}
          </div>
        );
      })}
    </pre>
  );
}
